<template>
    <div class="bg-grey-darkest h-full">

        <div class="w-full">
            <div class="p-4 bg-black">
                <h3>Stream Chat</h3>
            </div>
        </div>

        <div class="w-full" v-if="!loadedMessages">
            <!-- Loading -->
            <div class="py-10 text-center">
                <pulse-loader color="white"></pulse-loader>
            </div>
        </div>

        <div id="messagesContainer" style="height: calc(100vh - 197px);" class="w-full py-2 overflow-y-scroll" v-if="loadedMessages">
            <div class="break-words" v-for="message in messages">
                <message :message="message"></message>
            </div>
        </div>

        <div class="absolute pin-b pin-r w-100 mb-0 w-full" v-if="loadedMessages">
            <div class="bg-black p-2 clearfix flex items-center" v-if="isAuthenticated()">
                <textarea id="message" class="w-full bg-black text-white rounded border border-1 border-solid border-grey-dark p-2 outline-none" placeholder="Compose a message..." v-model="message" v-on:keyup.enter="postMessage"></textarea>
                <button :disabled="!messageExists" class="p-3 pr-2 outline-none" v-on:click="postMessage()">
                    <i class="fas fa-paper-plane text-white"></i>
                </button>
            </div>
            <div class="bg-black p-2 text-center" v-if="!isAuthenticated()">
                <p>You must be signed in to send messages.</p>
            </div>
        </div>

    </div>



</template>

<script>
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import Echo from 'laravel-echo'
    import moment from 'moment'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    window.io = require('socket.io-client')
    import Message from '@/components/Modules/Chat/Message'

    export default {
        name: 'chat',
        components: {
            PulseLoader,
            Message
        },
        data() {
            return {
                user: 'test',
                loadedMessages: false,
                messages: [],
                message: '',
            }
        },
        props: [
            'userId'
        ],
        computed: {
            messageExists() {
                var message = this.message
                return message.length !== 0;
            }
        },
        created() {
            window.Echo = new Echo({
                broadcaster: 'socket.io',
                host: 'https://staging-ws.livestormchasing.com'
            });
            window.Echo.channel(this.userId).listen('MessageSent', ({message}) => {
                console.log(message)
                this.messages.push(message);
                var _this = this
                setTimeout(function() {
                    _this.messagesUpdated()
                }, 1)
            });
            window.Echo.channel(this.userId).listen('MessageDeleted', ({message}) => {
                console.log(message)
                this.messages = this.messages.filter(function(obj) {
                    return obj.id !== message.id;
                })
            });

            this.getMessages()
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
                'isAuthenticated'
            ]),
            getMessages() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v1/chat/" + this.userId + "/messages").then((response) => {
                    this.$set(this, 'loadedMessages', true);
                    this.$set(this, 'messages', response.data);
                    // console.table(response.data)
                    // console.log("%cBlue! %cGreen", "color: blue; font-size:15px;", "color: green; font-size:12px;");
                });
            },
            postMessage() {
                var _this = this;

                this.$http.post(Config.apiPath + "/api/v1/chat/" + this.userId + "/messages", {
                    message: _this.message
                }, this.getAuthorizationHeader()).then((response) => {
                    _this.message = '';
                });
            },
            messagesUpdated() {
                var container = this.$el.querySelector("#messagesContainer");
                container.scrollTop = container.scrollHeight;
            }
        },
        filters: {
            displayMessageTime: function(date) {
                return moment.utc(date).local().format('h:mm');
            },
        }
    }
</script>

<style>
    nav a {
      text-decoration: none;
    }
    #message {
        resize: none;
    }
</style>
